import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';


export default function LinearProgressWithLabel(props) {
    const amount = (offer) => {
        if (offer.quantity > 0) {
            return `${offer.quantity-offer.remaining_value} / ${offer.quantity}`
        }
        return String.fromCharCode(8734)
    }
    return (
        <Box display="flex" alignItems="center" style={{width: '50%', maxWidth:100}}>
            <Box width="100%" mr={1}>
                <LinearProgress color={'secondary'} variant="determinate" {...props} />
            </Box>
            <Box minWidth={45}>
                <Typography variant="body2" color="textSecondary">{amount(props)}</Typography>
            </Box>
        </Box>
    );
}

